import { normalizePath, useSetFlowTo } from 'Simple/Flow'
import { useDataSubmit, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let setFlow = useSetFlowTo(props.viewPath)
  let steps = useDataValue({
    context: 'steps',
    path: 'steps',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'connection',
    viewPath: props.viewPath,
  })

  let submitSteps = useDataSubmit({
    context: 'steps',
    viewPath: props.viewPath,
  })

  let connection_id = useDataValue({
    viewPath: props.viewPath,
    context: 'connection',
    path: 'id',
  })

  return async function onClick() {
    if (steps.length > 0) {
      await submitSteps({ type: 'confirm' })
    } else {
      await submitSteps({ type: 'confirm' })
      await submit({
        type: 'activate_location_connection',
        connection_id,
      })
      setFlow(
        normalizePath(props.viewPath, '../../../../../../SetupAutomations/No')
      )
    }
  }
}

export function getText(steps) {
  return steps.some(step => step.step_type === 'automation')
    ? `This may add automations required for the integration to function properly.`
    : ''
}

export function isFirstConnectionText(connections) {
  return Array.isArray(connections) && connections?.length > 1
    ? `Are you sure you want to enable this connection for your current location?`
    : `Are you sure you want to enable the integration for your current location?`
}
